import { render, staticRenderFns } from "./SessionButton.vue?vue&type=template&id=450f46b4&scoped=true"
import script from "./SessionButton.vue?vue&type=script&lang=js"
export * from "./SessionButton.vue?vue&type=script&lang=js"
import style0 from "./SessionButton.vue?vue&type=style&index=0&id=450f46b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f46b4",
  null
  
)

export default component.exports